import { Bindable, Persistable, Remoteable, Supertype, supertypeClass } from '@haventech/amorphic';
import { Product } from '../../../../../common/js/static/Product';
import { Utils } from '../../../../../common/js/Utils';
import { CoverpathUtils } from '../../../../js/static/CoverpathUtils';
import { HtmlPdfUtils } from '../../HtmlPdfUtils';
import { IllustrationRequest } from '../../IllustrationRequest';

class CssStyle {
  productWarningStyle: string;
}

class ProductWarning {
  productWarningMain: string = '';
  css: CssStyle = new CssStyle();
}

@supertypeClass({ toClient: true, toServer: true })
export class HtmlPdfProductWarning extends Bindable(Remoteable(Persistable(Supertype))) {
  private templateFolder = './apps/coverpath-common/classes/wholelife/components/productwarning/templates/';

  async getHtmlContent(illustrationRequest: IllustrationRequest) {
    const warning = await HtmlPdfUtils.getContent(this.templateFolder, new ProductWarning());
    const style = `${warning.css.productWarningStyle}`;
    const productCode = illustrationRequest.productCode;
    const term = illustrationRequest.term;
    const longName = `${Product.products[productCode].name} ${term === 1 ? 'ART' : term}${
      productCode === Product.products.CASTermECP.code ? ' ECP' : ''
    }`;

    const body = warning.productWarningMain
      .replace(/{{ProductLongName}}/g, longName)
      .replace(/{{Date}}/, CoverpathUtils.getDateInPrettyFormat())
      .replace(/{{Gender}}/, illustrationRequest.gender.toUpperCase())
      .replace(/{{Age}}/, Utils.getAgeFromBirthday(illustrationRequest.dob.toLocaleDateString()))
      .replace(/{{FirstName}}/, illustrationRequest.customerPerson.firstName)
      .replace(/{{LastName}}/, illustrationRequest.customerPerson.lastName)
      .replace(/{{ProductCode}}/, `${illustrationRequest.productCode}${illustrationRequest.term}`);

    return HtmlPdfUtils.getHtmlContent(style, body);
  }
}
